import { formatNumber } from './format-number';

/**
 * DD-3687: a file size for display, scaled to the largest unit that keeps the
 * number readable.
 *
 * Binary units (1 KB = 1024 B), matching how the Usage page reports storage —
 * a lab comparing one archived file against its total should not have to
 * reconcile two definitions of a kilobyte.
 */
const BYTES_PER_UNIT = 1024;
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export const formatBytes = (valueInBytes: number | null | undefined): string => {
    if (valueInBytes === null || valueInBytes === undefined || Number.isNaN(valueInBytes)) {
        return '';
    }
    if (valueInBytes < BYTES_PER_UNIT) {
        return `${formatNumber(valueInBytes, { maximumFractionDigits: 0 })} ${UNITS[0]}`;
    }

    let scaledValue = valueInBytes;
    let unitIndex = 0;
    while (scaledValue >= BYTES_PER_UNIT && unitIndex < UNITS.length - 1) {
        scaledValue /= BYTES_PER_UNIT;
        unitIndex += 1;
    }
    return `${formatNumber(scaledValue, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} ${UNITS[unitIndex]}`;
};
